import { DataValidationError } from "constants/DataValidationError";
import { IsNotEmpty } from "class-validator";

export default class DeleteRoomReq {
  @IsNotEmpty({ message: DataValidationError.DATA_IS_EMPTY })
  roomId!: number;

  constructor(arg: any) {
    arg = arg || {};
    this.roomId = arg.roomId;
  }
}
